import { defineMessage } from 'services/localization';

export const messages = {
    nameColumnName: defineMessage('name'),
    supplierColumnName: defineMessage('supplier'),
    dateColumnName: defineMessage('date'),
    dueDateColumnName: defineMessage('due_date'),
    plannedDateColumnName: defineMessage('planned_date'),
    amountDueColumnName: defineMessage('amount_due'),
    outstandingBalance: defineMessage('you_owe_amount'),
    overdueBalance: defineMessage('overdue_amount'),
};
